//
//    Generated by trinidad-ui!
//
//
//    ██████╗  ██████╗     ███╗   ██╗ ██████╗ ████████╗    ███████╗██████╗ ██╗████████╗
//    ██╔══██╗██╔═══██╗    ████╗  ██║██╔═══██╗╚══██╔══╝    ██╔════╝██╔══██╗██║╚══██╔══╝
//    ██║  ██║██║   ██║    ██╔██╗ ██║██║   ██║   ██║       █████╗  ██║  ██║██║   ██║
//    ██║  ██║██║   ██║    ██║╚██╗██║██║   ██║   ██║       ██╔══╝  ██║  ██║██║   ██║
//    ██████╔╝╚██████╔╝    ██║ ╚████║╚██████╔╝   ██║       ███████╗██████╔╝██║   ██║
//    ╚═════╝  ╚═════╝     ╚═╝  ╚═══╝ ╚═════╝    ╚═╝       ╚══════╝╚═════╝ ╚═╝   ╚═╝
//
//
//    All changes in this file will be overwritten next time
//    someone adds or generates new assets.
//
//    Read more on https://git.svenskaspel.se/trinidad/trinidad-ui ...
//
//    @author Team Design-tech
//
//    ---

import PropTypes from 'prop-types';
import './../stylesheets/icon.less';
import './../stylesheets/icon-custom.less';

const Icon = ({
  color,
  className,
  title,
  size,
  icon,
  ...props
}) => {
  const componentClasses = ['icon'];

  componentClasses.push(color ? color : 'icon-default');
  if (props.class) {
    componentClasses.push(props.class);
  } // deprecated
  if (title) {
    componentClasses.push(title);
  }
  if (className) {
    componentClasses.push(className);
  }
  if (size) {
    componentClasses.push(`icon-${size}`);
  }
  if (icon) {
    componentClasses.push(`icon-${icon}`);
  }

  return (
    <i className={componentClasses.join(' ')} />
  );
};

Icon.defaultProps = {
  size: '300'
};

Icon.propTypes = {
  class: PropTypes.string,
  className: PropTypes.string,
  color: PropTypes.string,
  icon: PropTypes.string.isRequired,
  size: PropTypes.string,
  title: PropTypes.string
};

export default Icon;
